import React, { useState } from "react";
import { SERVICES } from "../mock";
import { Plus, Minus } from "lucide-react";

export default function Services() {
  const [open, setOpen] = useState("strategie");

  return (
    <section id="competences" className="relative py-24 md:py-40 px-6 md:px-10 border-t border-white/5 bg-black/25 backdrop-blur-sm">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <span className="font-mono text-xs uppercase tracking-widest text-[#FF5B24]">
              (02) — Compétences
            </span>
            <h2 className="font-display font-medium text-4xl md:text-7xl mt-6 leading-[1.02] tracking-[-0.03em] max-w-3xl">
              Quatre métiers. <span className="font-serif-i text-white/60">Un seul geste.</span>
            </h2>
          </div>
          <p className="max-w-sm text-white/60">
            De l'archéologie de marque à la production : nous couvrons l'intégralité du geste créatif, en interne.
          </p>
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {SERVICES.map((s) => {
            const isOpen = open === s.id;
            return (
              <div key={s.id} className="group">
                <button
                  onClick={() => setOpen(isOpen ? null : s.id)}
                  className="w-full grid grid-cols-12 items-center py-6 md:py-8 text-left gap-4"
                >
                  <div className="col-span-2 md:col-span-1 font-mono text-xs md:text-sm text-white/40">
                    {s.number}
                  </div>
                  <div className="col-span-8 md:col-span-6">
                    <div className="font-display text-2xl md:text-4xl font-medium tracking-[-0.02em] group-hover:text-[#FF5B24] transition-colors">
                      {s.title}
                    </div>
                  </div>
                  <div className="hidden md:block md:col-span-4 font-serif-i text-white/50 text-lg">
                    {s.subtitle}
                  </div>
                  <div className="col-span-2 md:col-span-1 flex justify-end">
                    <span className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#FF5B24] group-hover:border-[#FF5B24] group-hover:text-black transition-all">
                      {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </span>
                  </div>
                </button>
                <div
                  className="grid transition-all duration-500 overflow-hidden"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="min-h-0">
                    <div className="pb-8 md:pb-12 grid md:grid-cols-12 gap-4">
                      <div className="md:col-start-3 md:col-span-9">
                        <ul className="grid md:grid-cols-2 gap-x-8 gap-y-2 text-white/70 text-base md:text-lg">
                          {s.points.map((p) => (
                            <li key={p} className="flex items-start gap-3">
                              <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#FF5B24] shrink-0" />
                              {p}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
